import styled from '@emotion/styled';
import { getBorders, box } from '../style';

export const EmailAutoSuggestWrapper = styled('div')({
  position: 'relative',
  maxWidth: '452px',
  width: '100%',
});

export const AutoSuggestList = styled('ul')({
  ...box,
  boxSizing: 'border-box',
  boxShadow: '0px 5px 6px 0px rgba(0,0,0,0.3)',
  position: 'absolute',
  margin: 0,
  padding: 0,
  backgroundColor: '#ffffff',
  zIndex: 9991,
  top: '67px',
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  width: '100%',
  borderTop: 0,
  border: '1px solid rgba(0,0,0,0.15)',
  '> li.active': {
    backgroundColor: '#F5F7FA',
    cursor: 'default',
  },
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const AutoSuggestListItem = styled('li')(() => ({
  listStyle: 'none',
  margin: '0px 12px',
  padding: '0px 4px',
  lineHeight: '30px',
  overflow: 'hidden',
  textWrap: 'nowrap',
  ':first-of-type': {
    borderTop: getBorders().DASHED,
  },
  ':last-of-type': {
    marginBottom: '5px',
  },
  ':hover': {
    backgroundColor: '#F5F7FA',
    cursor: 'default',
  },
}));
